import React from "react";


const TabSelector = ({
  t,
  activePlanningTab,
  setActivePlanningTab
}: any) => (
            <section className="lumen-plain-card rounded-2xl p-2">
              <div className="flex flex-col gap-2 sm:flex-row">
                {[
                  {
                    key: "overview",
                    label: t("schoolCalendar.tabs.overview", {
                      defaultValue: "Overview",
                    }),
                  },
                  {
                    key: "yearPlanner",
                    label: t("schoolCalendar.tabs.yearPlanner", {
                      defaultValue: "Year planner",
                    }),
                  },
                ].map((tab) => (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => setActivePlanningTab(tab.key)}
                    className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${
                      activePlanningTab === tab.key
                        ? "bg-indigo-600 text-white shadow-sm"
                        : "text-gray-700 hover:bg-indigo-50 dark:text-gray-200 dark:hover:bg-gray-800"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </section>
);

export default TabSelector;
